module.exports = __webpack_public_path__ + "static/media/stage-2.244848e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/DevelopingABrandCharacter/stage-2.jpg
// module id = 411
// module chunks = 0